module.exports = __webpack_public_path__ + "static/img/no-comment.ac85289f.png";